import { useEffect, useState } from 'react';
import {
  Alert,
  Paper,
  Stack,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';
const KINDS = {
  ADDED: 'Dodana pozycja',
  REMOVED: 'Pozycja poza zakresem',
  CHANGED: 'Zmiana',
  NEW_ISSUE: 'Nowy problem',
  RESOLVED: 'Rozwiązane',
};
export default function SimulationReportPanel({ run, transports = [] }) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [changePage, setChangePage] = useState(0);
  useEffect(() => {
    setPage(0);
    setChangePage(0);
  }, [run.id, search]);
  const matches = (i) =>
    [
      i.transportNumber,
      i.deliveryNumber,
      i.positionNumber,
      i.materialNumber,
      i.description,
    ].some((v) =>
      String(v ?? '')
        .toLowerCase()
        .includes(search.trim().toLowerCase()),
    );
  const positions = transports
    .flatMap((t) =>
      t.positions.map((p) => ({ ...p, transportNumber: t.transportNumber })),
    )
    .filter(matches);
  const changes = (run.comparison?.changes ?? []).filter(matches);
  const pager = (count, current, set) => (
    <TablePagination
      component="div"
      count={count}
      page={current}
      rowsPerPage={25}
      rowsPerPageOptions={[25]}
      onPageChange={(_, p) => set(p)}
      labelDisplayedRows={({ from, to, count }) => `${from}–${to} z ${count}`}
    />
  );
  const identity = (i) =>
    `Transport ${i.transportNumber} · dostawa ${i.deliveryNumber} · poz. ${i.positionNumber} · materiał ${i.materialNumber}`;
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Co zrobić?</Typography>
        <TextField
          size="small"
          label="Filtruj działania i zmiany"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Typography variant="subtitle1">
          Działania ({positions.length} pozycji)
        </Typography>
        {positions.slice(page * 25, (page + 1) * 25).map((p, i) => (
          <div key={i}>
            <Typography fontWeight="bold">{identity(p)}</Typography>

            <ul style={{ marginTop: 4, paddingLeft: 20, fontSize: '1rem' }}>
              {p.actions.map((a, j) => (
                <li key={j}>{a}</li>
              ))}
            </ul>
          </div>
        ))}
        {!positions.length && (
          <Typography>Brak działań dla wybranego zakresu.</Typography>
        )}
        {pager(positions.length, page, setPage)}
        <Typography variant="subtitle1">
          Co się zmieniło? ({changes.length})
        </Typography>
        {run.comparison?.preview && (
          <Alert severity="info">
            Ręczny podgląd — bez porównania i maili.
          </Alert>
        )}
        {run.comparison?.historical && (
          <Alert severity="info">Wynik historyczny — bez powiadomień.</Alert>
        )}
        {run.comparison?.baseline && <Typography>Pierwsza analiza.</Typography>}
        {!run.comparison && (
          <Typography>
            Ten wynik powstał przed wprowadzeniem porównywania zmian.
          </Typography>
        )}
        {changes.slice(changePage * 25, (changePage + 1) * 25).map((c, i) => (
          <div key={i}>
            <Typography fontWeight="bold">
              {KINDS[c.kind]} · {identity(c)}
            </Typography>

            <ul style={{ marginTop: 4, paddingLeft: 20, fontSize: '1rem' }}>
              {c.messages.map((m, j) => (
                <li key={j}>{m}</li>
              ))}
            </ul>
          </div>
        ))}
        {run.comparison && !run.comparison.preview && !changes.length && (
          <Typography>Brak istotnych zmian w wybranym zakresie.</Typography>
        )}
        {pager(changes.length, changePage, setChangePage)}
      </Stack>
    </Paper>
  );
}
